module.exports = __webpack_public_path__ + "static/media/05_a.29baa870.png";